import { FREIGHT_MANUAL_LINE } from '@evi/shared';

/**
 * Lines on the job page that follow a rule (walkthrough counts, 21 October 2026, steps 039 and 059). Pure, so the words
 * are unit-tested (jobPageLines.test.ts).
 */

/**
 * The driver price as information, never in the problem style: "Drivers pay $0.33 per kWh (floor: no market price for
 * this area yet)". A job with Level 2 and DC chargers names the type on each line.
 */
export function driverPayLine(t: { label: string | null; cents_per_kwh: number; how: string | null }, many: boolean, format: (cents: number) => string): string {
  return `${many && t.label ? `${t.label}: drivers` : 'Drivers'} pay ${format(t.cents_per_kwh)} per kWh${t.how ? ` (${t.how})` : ''}`;
}

/**
 * Whether the job's freight is on the manual path, quoted by EVI by hand: before payment, the live line came back manual
 * or could not be priced; after it, the order is with EVI's freight desk rather than priced by the carrier.
 */
export function freightIsManual(o: { paid: boolean; freightStatus?: string | null; pricedByCarrier: boolean; line?: { outcome: string } | null; lineFailed?: boolean }): boolean {
  if (o.paid) return !!o.freightStatus && !o.pricedByCarrier;
  return o.line?.outcome === 'manual' || (!o.line && !!o.lineFailed);
}

/**
 * The Order card's freight cell before the freight is with a carrier: one wording on the manual path, "Freight quote
 * within one business day", and nothing else (never "Priced at checkout" beside it).
 */
export function freightCell(o: { freightStatus?: string | null; manual: boolean }, labels: Record<string, string>): string {
  if (o.freightStatus) return o.freightStatus === 'awaiting_quote' ? FREIGHT_MANUAL_LINE : labels[o.freightStatus] ?? o.freightStatus;
  return o.manual ? FREIGHT_MANUAL_LINE : 'Priced at checkout';
}

/**
 * The next step's dates (Warren, 21 October 2026: "Expected to ship about Nov 18. Expected delivery about Nov 21."). On
 * the manual path, before a delivery date is known, the ship date alone: the freight line already says when the quote
 * comes, so the page never words it a second way ("Delivery follows the freight quote").
 */
export function expectedLine(e: { line: string | null; ship_text?: string | null; delivery_date: string | null }, manual: boolean): string | null {
  return manual && !e.delivery_date && e.ship_text !== undefined ? e.ship_text : e.line;
}

/** Under the partner's order button: how it pays. On the manual path the freight's timing is its own line above, so this
 * says only that EVI emails the link to pay it. */
export function orderPayHint(priced: boolean, toSite: boolean): string {
  return `You pay the hardware at MSRP with your own card${priced ? ', and the freight with it' : ''}. ${priced || !toSite ? 'Nothing ships until it is paid.'
    : 'EVI emails you the link to pay the freight; nothing ships until it is paid.'}`;
}
